import { baseDomain } from "../../config"
import { get } from "svelte/store"
import { location } from "../store"

export function getCookie(name: string) {
    let cookieArr = document.cookie.split(";")
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=")
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1])
        }
    }
    return null
}

export function setCookie(name: string, value: string) {
    document.cookie = `${name}=${value}; domain=.${baseDomain}; path="/"; secure; samesite=none; max-age=31536000;`
}
export function deleteCookie(name: string) {
    document.cookie = `${name}=; domain=.${baseDomain}; path="/"; secure; SameSite=None; expires=Thu, 01 Jan 1970 00:00:00 GMT;`
}

function hasParentWithClass(element: HTMLElement, classname: string): any {
    if (typeof element.className == "string" && element.className.split(" ").indexOf(classname) >= 0) return true
    return element.parentNode && hasParentWithClass(element.parentNode as HTMLElement, classname)
}

export function clickOutside(node: Node, callback: Function) {
    const handleOutsideClick = ({ target }: MouseEvent) => {
        if (!node.contains(target as Node) && !hasParentWithClass(target as HTMLElement, "tooltip")) {
            callback(target)
        }
    }

    typeof window !== "undefined" && window.addEventListener("click", handleOutsideClick, true)

    return {
        destroy() {
            typeof window !== "undefined" && window.removeEventListener("click", handleOutsideClick, true)
        },
    }
}
export function getQueryParam(param: string) {
    return new URLSearchParams(get(location).search).get(param)
}
